<template>
    <div class="message xmalert alert-box"
         :class="status"
         role="alert"
         v-show="show"
         style="visibility: visible; opacity: 1; position: fixed; z-index: 100000;
          transition: all 0.3s ease-in-out 0s; bottom: 30px; top: auto; left: auto; right: 30px;">
        <div class="message-type">
            <i v-if="status == 'success'" aria-hidden="true" class="fa fa-check"></i>
            <i v-if="status == 'info'" aria-hidden="true" class="fa fa-info"></i>
            <i v-if="status == 'error'" aria-hidden="true" class="fa fa-exclamation-triangle"></i>
        </div>
        <p class="text-header" v-text="body"></p>
        <i @click="show = false" alt="close-icon" aria-hidden="true" class="close-btn fa fa-times"></i>
    </div>
</template>

<script>
    export default {
        props: ['message'],
        data() {
            return {
                body: this.message,
                status: 'success',
                show: false
            }
        },
        created() {
            if (this.message) {
                this.flash();
            }
            window.events.$on(
                'flash', data => this.flash(data)
            );
        },
        methods: {
            flash(data) {
                if (data) {
                    this.body = data.message;
                    this.status = data.status;
                }
                this.show = true;
                this.hide();
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            }
        }
    };
</script>

<style>
    .alert-flash {
        position: fixed;
        right: 25px;
        bottom: 25px;
    }
</style>